<app-form-input 
[parentForm]="parentForm" 
[value]="voie?.num" 
[label]="step2.getnum"
[type]="'text'"
[rule]="'minSize_1|maxSize_50|required'"
[errorMessage]="{'required' : 'ctr_1031_jira'}"
[name]="getUid()+'_SepAtt_num'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="voie?.typevoie" 
[label]="step2.gettypevoie"
[type]="'text'"
[rule]="'minSize_1|maxSize_255|required'"
[name]="getUid()+'_SepAtt_typevoie'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="voie?.nomvoie" 
[label]="step2.getnomvoie"
[type]="'text'"
[rule]="'minSize_5|maxSize_1000|required'"
[name]="getUid()+'_SepAtt_nomvoie'">
</app-form-input>
